export const sendGaEvent = (name: string, data: {} = {}) => {
  window?.gtag('event', name, data);
};